import { connect } from 'react-redux'
import CmsPage from './CmsPage'

const mapStateToProps = ({ cms }, { route }) => ({
  page: cms.page && cms.page.find(item => item.fields.slug === route.path),
})

const dispatchToProps = {}

export default connect(mapStateToProps, dispatchToProps)(CmsPage)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/CmsPage/CmsPage.container.js